if (!customElements.get('theme-mode-control')) {
  customElements.define(
    'theme-mode-control',
    class ThemeModeControl extends HTMLElement {
      connectedCallback() {
        this.storageKey = this.dataset.storageKey || 'cardlegends-theme-mode';
        this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        this.toggle = this.querySelector('[data-theme-mode-toggle]');
        this.handleSystemChange = this.handleSystemChange.bind(this);
        this.handlePreferenceChange = this.handlePreferenceChange.bind(this);

        this.toggle?.addEventListener('click', () => this.togglePreference());
        this.mediaQuery.addEventListener?.('change', this.handleSystemChange);
        document.addEventListener('cardlegends:theme-preference', this.handlePreferenceChange);
        this.updateToggle(document.documentElement.dataset.theme || 'light');
      }

      disconnectedCallback() {
        this.mediaQuery?.removeEventListener?.('change', this.handleSystemChange);
        document.removeEventListener('cardlegends:theme-preference', this.handlePreferenceChange);
      }

      setPreference(preference) {
        if (!['light', 'dark', 'system'].includes(preference)) return;

        try {
          localStorage.setItem(this.storageKey, preference);
        } catch (error) {
          // The immediate mode change still works when persistent storage is unavailable.
        }

        document.documentElement.dataset.themePreference = preference;
        this.applyResolvedMode(preference);
        this.updateToggle(document.documentElement.dataset.theme);
        document.dispatchEvent(new CustomEvent('cardlegends:theme-preference', { detail: { preference } }));
      }

      togglePreference() {
        const currentMode = document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
        this.setPreference(currentMode === 'dark' ? 'light' : 'dark');
      }

      applyResolvedMode(preference) {
        const resolvedMode = preference === 'system' ? (this.mediaQuery.matches ? 'dark' : 'light') : preference;
        document.documentElement.dataset.theme = resolvedMode;
        document.documentElement.style.colorScheme = resolvedMode;
      }

      handleSystemChange() {
        if (document.documentElement.dataset.themePreference === 'system') {
          this.applyResolvedMode('system');
          this.updateToggle(document.documentElement.dataset.theme);
        }
      }

      handlePreferenceChange(event) {
        const preference = event.detail.preference;
        const resolvedMode = preference === 'system' ? (this.mediaQuery.matches ? 'dark' : 'light') : preference;
        this.updateToggle(resolvedMode);
      }

      updateToggle(mode) {
        if (!this.toggle) return;
        const isDark = mode === 'dark';
        this.toggle.setAttribute('aria-label', isDark ? this.toggle.dataset.darkLabel : this.toggle.dataset.lightLabel);
        this.toggle.setAttribute('data-current-mode', isDark ? 'dark' : 'light');
      }
    }
  );
}
